var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEspera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "hourglass"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 3.22727C3 2.82561 3.39175 2.5 3.875 2.5H16.125C16.6082 2.5 17 2.82561 17 3.22727C17 3.62893 16.6082 3.95455 16.125 3.95455H15.25V6.26145C15.2499 6.84003 14.9732 7.39501 14.481 7.80408C14.4809 7.8041 14.481 7.80405 14.481 7.80408L11.2374 10.5L14.4809 13.1958C14.4808 13.1958 14.4809 13.1959 14.4809 13.1958C14.9731 13.6049 15.2499 14.1598 15.25 14.7384V17.0455H16.125C16.6082 17.0455 17 17.3711 17 17.7727C17 18.1744 16.6082 18.5 16.125 18.5H3.875C3.39175 18.5 3 18.1744 3 17.7727C3 17.3711 3.39175 17.0455 3.875 17.0455H4.75V14.7385C4.75015 14.16 5.02677 13.605 5.51903 13.1959C5.519 13.1959 5.51906 13.1959 5.51903 13.1959L8.76256 10.5L5.51912 7.80416C5.51909 7.80413 5.51916 7.80418 5.51912 7.80416C5.02687 7.39509 4.75015 6.84018 4.75 6.26161V3.95455H3.875C3.39175 3.95455 3 3.62893 3 3.22727ZM6.5 3.95455V6.2613C6.5 6.26125 6.5 6.26135 6.5 6.2613C6.5001 6.45411 6.59231 6.63916 6.75638 6.77548L10 9.47148L13.2435 6.77556C13.4076 6.63924 13.4999 6.45427 13.5 6.26145C13.5 6.2614 13.5 6.26151 13.5 6.26145V3.95455H6.5ZM10 11.5285L6.75647 14.2244C6.59241 14.3608 6.5001 14.5457 6.5 14.7385C6.5 14.7385 6.5 14.7386 6.5 14.7385V17.0455H13.5V14.7387C13.5 14.7386 13.5 14.7388 13.5 14.7387C13.4999 14.5459 13.4077 14.3608 13.2436 14.2245L10 11.5285Z",
    fill: "#F2D0A9"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEspera);
export default __webpack_public_path__ + "static/media/espera.5cf836e35c7f981d942445128988db8a.svg";
export { ForwardRef as ReactComponent };